import {readAsArrayBuffer} from './asyncReader.js';
import { getAsset } from './prepareAssets';
import { noop } from './helper.js';
import Konva from "konva";
import constants from "../../../../constants";
// import {rgb} from "pdf-lib";
// import Konva from "konva";

export async function save(pdfFile, objects) {
  const PDFLib = await getAsset('PDFLib');
  let tokenImages = [];
  let scale = constants.DETAIL_DOCS_PAGE.PDF_DEFAULT_SCALE;
  let pdfDoc;
  try {
    pdfDoc = await PDFLib.PDFDocument.load(await readAsArrayBuffer(pdfFile));
  } catch (e) {
    console.log('Failed to load PDF.');
    throw e;
  }
  const pagesProcesses = pdfDoc.getPages().map(async (page, pageIndex) => {
    const pageObjects = objects[pageIndex];
    // 'y' starts from bottom in PDFLib, use this to calculate y

    const embedProcesses = pageObjects.map(async (object) => {
      if (object.type === 'image') {
        try {
          let { file, x, y, width, height, pIndex, pageHeight } = object;
          const tokenImage = {
            page: pIndex + 1,
            px: x,
            py: (pageHeight / scale - y - height),
            pw: (x + width),
            ph: (pageHeight / scale - y),
            imageData: file
          }
          tokenImages.push(tokenImage);
        } catch (e) {
          console.log('Failed to embed image.', e);
          return noop;
        }
      } else if (object.type === 'text' || object.type === 'textTransparent') {
        try {
          let { x, y, pIndex, text, size, align, fontWeight, fontStyle, pageHeight } = object;

          let width;
          let height;
          let layer = new Konva.Layer();
          let textUpscale = 10

          if (fontWeight === constants.DETAIL_DOCS_PAGE.FONTSTYLE.BOLD && fontStyle === constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC) {
            fontStyle = fontWeight + ' ' + fontStyle;
          }

          if (fontStyle === null || fontStyle === '') {
            fontStyle = fontWeight;
          }

          if (text.toString().includes("\n")) {
            const lines = text.toString().split("\n");
            height = Math.round(size * textUpscale * lines.length) + 20;
            let listTempWidth = [];

            lines.forEach((line, index) => {
              const textKonva = new Konva.Text({
                x: 0,
                y: index * size * textUpscale + 20,
                text: line,
                fontSize: size * textUpscale,
                fontFamily: 'Times New Roman',
                fill: 'black',
                align: align,
                fontStyle: fontStyle
              });

              let tempWidth = Math.round(textKonva.textWidth + textUpscale);
              textKonva.width(tempWidth);

              listTempWidth.push(tempWidth);

              layer.add(textKonva);
            });

            width = Math.max(...listTempWidth);
          } else {
            const textKonva  = new Konva.Text({
              x: 0,
              y: 0,
              text: text,
              fontSize: size * textUpscale,
              fontFamily: 'Times New Roman',
              fill: 'black',
              align: align,
              fontStyle: fontStyle
            });

            width = Math.round(textKonva.textWidth + textUpscale);
            height = Math.round(textKonva.textHeight);

            textKonva.width(width);
            textKonva.height(height);

            layer.add(textKonva);

            // if (object.text.toString().includes('ngày')) {
            //   const textGroup = new Konva.Group({
            //     x: 0,
            //     y: 0
            //   });
            //
            //   // Add the background Rect to the group
            //   const backgroundRect = new Konva.Rect({
            //     fill: 'white',
            //     width: width,
            //     height: height
            //   });
            //
            //   textGroup.add(backgroundRect);
            //   textGroup.add(textKonva);
            //   layer.add(textGroup);
            //
            // } else {
            //   layer.add(textKonva);
            // }
          }

          const konvaContainer = document.createElement("konvaContainer");

          const stage = new Konva.Stage({
            container: konvaContainer,
            width: width,
            height: height
          });

          stage.add(layer);

          const tokenImage = {
            page: pIndex + 1,
            px: x,
            py: pageHeight / scale - y - (height / textUpscale),
            pw: x + (width / textUpscale),
            ph: pageHeight / scale - y,
            imageData: stage.toDataURL()
          }
          tokenImages.push(tokenImage);
        } catch (e) {
          console.log('Failed to embed text image.', e);
          return noop;
        }
      }
    });
    console.log(embedProcesses);
    // embed objects in order
    // const drawProcesses = await Promise.all(embedProcesses);
    // console.log(embedProcesses);
    // drawProcesses.forEach((p) => p());
  });
  console.log(pagesProcesses);
  // await Promise.all(pagesProcesses);
  // try {
  //   const pdfBytes = await pdfDoc.save();
  //   download(pdfBytes, name, 'application/pdf');
  // } catch (e) {
  //   console.log('Failed to save PDF.');
  //   throw e;
  // }
  console.log(tokenImages);
  return tokenImages;
}



// WEBPACK FOOTER //
// ./src/views/doc-in/components/pdf-lib-utils/PDF.js